export default __webpack_public_path__ + "static/media/photo--sm--98.e57c48df.jpg";